import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Camera } from '@liveauctioneers/hammer-ui-core/icons';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { SEARCH_BY_IMAGE_TRIGGER_ID } from './components/SearchByImageEducationPopover';
import { useSearchByImageSurface } from './hooks/useSearchByImageSurface';

/**
 * treatmenta entry point: a camera trigger rendered beside the header search input (as its
 * trailingContent), responsive per the SEAR-1251 Figma — a labelled Button on tablet+ and a
 * compact IconButton on mobile. Both open the shared upload popover (desktop) / bottom sheet
 * (mobile). Only mounted for treatmenta; exposure is owned by HammerHeader.
 */
export const SearchByImageTrailingButton = () => {
    const formatMessage = useAppFormatMessage();
    const { containerRef, education, isMobile, isOpen, onTriggerClick, surface } = useSearchByImageSurface();
    const label = String(formatMessage(['visualSearch', 'searchByImage']));

    return (
        <div
            className="relative flex items-center"
            ref={containerRef}
        >
            {isMobile ? (
                <IconButton
                    aria-expanded={isOpen}
                    aria-haspopup="dialog"
                    aria-label={label}
                    hideTooltip
                    icon={Camera}
                    id={SEARCH_BY_IMAGE_TRIGGER_ID}
                    onClick={onTriggerClick}
                    size="sm"
                    style="neutral"
                    type="button"
                    variant="transparent"
                />
            ) : (
                <Button
                    aria-expanded={isOpen}
                    aria-haspopup="dialog"
                    // Button's outlined default is px-md (24px) / py-sm (16px); Figma wants a
                    // symmetric 16px inset, so pull the horizontal padding down to match.
                    className="px-sm"
                    iconLeft={Camera}
                    id={SEARCH_BY_IMAGE_TRIGGER_ID}
                    onClick={onTriggerClick}
                    style="neutral"
                    type="button"
                    variant="outlined"
                >
                    {label}
                </Button>
            )}
            {education}
            {surface}
        </div>
    );
};
